import React from "react";
import "../css/ExportConfirmationModal.css";

const ExportConfirmationModal = ({ isOpen, onClose, onConfirm, isLoading }) => {
  if (!isOpen) return null;

  return (
    <div className="export-confirmation-modal-overlay">
      <div className="export-confirmation-modal-content">
        <button className="export-confirmation-modal-close" onClick={onClose}>
          ×
        </button>
        <div className="export-confirmation-modal-message">
          Data will be exported and sent over email.
        </div>
        <div className="export-confirmation-modal-question">
          Do you want to continue?
        </div>
        <div className="export-confirmation-modal-buttons">
          <button
            className="export-confirmation-modal-yes-button"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? "Loading..." : "Yes"}
          </button>
          <button
            className="export-confirmation-modal-cancel-button"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExportConfirmationModal;
